import React, { useState, useRef } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import { CommonPickerMethods } from 'antd/es/date-picker/generatePicker/interface';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useAllowedTimeRangeMoment } from './hooks';

const { RangePicker } = DatePicker;

const CustomDateRangePicker = ({ setDateCb, selectedInterval }) => {
  const [open, setOpen] = useState(false);
  const refRangePicker = useRef<CommonPickerMethods>(null);

  const { startTimeMoment, endTimeMoment } = useAllowedTimeRangeMoment();

  const onCustomSelection = (interval) => {
    if (!interval?.[0] || !interval?.[1]) return;
    const currentInterval = {
      from: moment(interval[0]).format(),
      to: moment(interval[1]).format(),
      shortcut: 'custom',
    };

    setOpen(false);
    setTimeout(() => {
      if (refRangePicker.current) {
        refRangePicker.current?.blur();
      }
      setDateCb(currentInterval, 'datepicker');
    }, 2);
  };

  const disableDates = (calendarDate) => {
    const calendarDateMoment = moment(calendarDate);

    return (
      calendarDateMoment.isAfter(endTimeMoment) || calendarDateMoment.isBefore(startTimeMoment)
    );
  };

  return (
    <RangePicker
      ref={refRangePicker}
      open={open}
      style={{
        width: '370px',
      }}
      transitionName={''}
      value={[moment(selectedInterval.from) as any, moment(selectedInterval.to)] as any}
      disabledDate={disableDates}
      onOpenChange={(open) => {
        setOpen(open);
      }}
      separator={<ArrowRightOutlined />}
      onChange={onCustomSelection}
      showTime={{
        defaultValue: [
          moment('00:00:00', 'HH:mm:ss') as any,
          moment('23:59:59', 'HH:mm:ss') as any,
        ],
      }}
    />
  );
};

export default CustomDateRangePicker;
